/**
 * Propery module holds all of the properties details
 */
var propertyModule = angular.module('property',[]);
var property = {};
property.id = (typeof propertyId === 'undefined') ? null : propertyId;
property.name = (typeof propertyName === 'undefined') ? null : propertyName;
property.defaultCurrency = (typeof defaultCurrency === 'undefined') ? null : defaultCurrency;
property.takeCreditCard = (typeof takeCreditCard === 'undefined') ? null : takeCreditCard;
property.propertyHomeAddress = (typeof propertyHomeAddress === 'undefined' && propertyHomeAddress) ? null : propertyHomeAddress;
if(typeof redirectOverride !== 'undefined' && redirectOverride){
    property.propertyHomeAddress = redirectOverride;
}
property.minDateCheckin = moment().format('YYYY-MM-DD');
property.policies = {};

// property details
property.description = null;
property.checkinTime = null;
property.checkoutTime = null;
property.receptionHours = null;
property.directionsToProperty = null;
property.additionalInfo = null;
property.facilities = null;
property.roomFacilities = null;
property.parking = null;
property.distances = null;
property.directions = null;
property.allowSameDayBookings = (typeof allowSameDay === 'undefined') ? null : allowSameDay;
property.photos = [];
property.showRedirectConfirm = false;
property.addressAutocompleteProvider = (typeof addressAutoCompleteProvider === 'undefined') ? false : addressAutoCompleteProvider;
property.addressProviderScript = (typeof addressProviderScript === 'undefined') ? false : addressProviderScript;
property.addressingToken = (typeof addressingToken === 'undefined') ? '' : addressingToken;
property.insuranceErrorMessage = "";
property.showInsuranceError = false;

// property insurance
property.offersInsurance = (typeof offersInsurance === 'undefined') ? false : offersInsurance;
property.insuranceMultiplier = (typeof insuranceMultiplier === 'undefined') ? null : insuranceMultiplier;
property.insuranceProvider = (typeof insuranceProvider === 'undefined') ? null : insuranceProvider;
property.insurancePremiumMinimum = (typeof insurancePremiumMinimum === 'undefined') ? null : insurancePremiumMinimum;
property.insuranceMinDuration = (typeof insuranceMinDuration === 'undefined') ? null : insuranceMinDuration;
property.insuranceMaxDuration = (typeof insuranceMaxDuration === 'undefined') ? null : insuranceMaxDuration;
property.insuranceMaxLeadMonths = (typeof insuranceMaxLeadMonths === 'undefined') ? null : insuranceMaxLeadMonths;
property.insuranceCoverMinAge = (typeof insuranceCoverMinAge === 'undefined') ? null : insuranceCoverMinAge;
property.insuranceCoverMaxAge = (typeof insuranceCoverMaxAge === 'undefined') ? null : insuranceCoverMaxAge;
property.insuranceExtraName = (typeof insuranceExtraName === 'undefined') ? '' : insuranceExtraName;

// property policies
property.paymentPolicy = null;
property.cancellationPolicy = null;
property.childPolicy = null;
property.checkinPolicy = null;

// fields for availability calendar
property.showAvailabilityCal = (typeof showAvailabilityCal === 'undefined') ? null : showAvailabilityCal;
property.accountId = (typeof accountId === 'undefined') ? null : accountId;
property.filteredBookables = (typeof filteredBookables === 'undefined') ? [] : filteredBookables;

property.roomsCount = (typeof roomsCount === 'undefined') ? null : roomsCount;
property.maxBookingNights = 31;
property.template = {};
property.template.id = (typeof templateId === 'undefined') ? null : templateId;
property.rooms = [];
property.extras = [];
property.extrasPhotos = [];
property.extrasPrices = [];
property.extraCategories = [];
property.prices = [];
property.roomAvailabilities = [];

property.templateSettings = {};
property.templateSettings.showRemainingRooms = (typeof showRemainingRooms === 'undefined') ? null : showRemainingRooms;
property.templateSettings.promoText = (typeof promoText === 'undefined') ? null : promoText;
property.templateSettings.defaultStay = (typeof defaultStay === 'undefined') ? null : defaultStay;
property.templateSettings.hideExtras = true;

// extras settings
property.canSkipExtras = (typeof bypassExtras === 'undefined') ? null : bypassExtras;

// extra only bookings
property.isItemOnly = (typeof isItemOnly === 'undefined') ? null : isItemOnly;

// multi prop bookings
property.isMultiProp = (typeof isMultiProp === 'undefined') ? null : isMultiProp;

property.guestsByRoom = {};
property.guestsByRoom.GuestNames = (typeof collectGuestsPerRoom === 'undefined') ? null : collectGuestsPerRoom;//'hidden';//'optional';//'mandatory';
property.guestsByRoom.AdultAges = (typeof requireAdultAges === 'undefined') ? null : requireAdultAges;
property.guestsByRoom.ChildAndInfantAges = (typeof requireChildAndInfantAges === 'undefined') ? null : requireChildAndInfantAges;
property.guestsByRoom.ETA = (typeof requireETA === 'undefined') ? null : requireETA;//'hidden';//'optional';//'mandatory';
property.guestsByRoom.vehicleReg = (typeof requireRoomVehReg === 'undefined') ? null : requireRoomVehReg;

property.availableETAs = (typeof etaListings === 'undefined') ? null : etaListings;

// takes promo codes
property.acceptsPromoCodes = (typeof acceptsPromoCodes === 'undefined') ? null : acceptsPromoCodes;
property.promoCodeLabel = (typeof promoCodeLabel === 'undefined') ? null : promoCodeLabel;
property.promoCodeValidateLabel = (typeof promoCodeValidateLabel === 'undefined') ? null : promoCodeValidateLabel;
property.promoCodePromptText = (typeof promoCodePromptText === 'undefined') ? null : promoCodePromptText;
property.promoCodeTitle = (typeof promoCodeTitle === 'undefined') ? null : promoCodeTitle;
property.promoCodeDescription = (typeof promoCodeDescription === 'undefined') ? null : promoCodeDescription;

// show more
property.showMoreLabel = (typeof showMoreLabel === 'undefined') ? 'Show More' : showMoreLabel;

// property hot deals
property.hotDealPercentage = (typeof hotDealPercentage === 'undefined') ? null : hotDealPercentage;
property.showHotDeal = (typeof showHotDeal === 'undefined') ? null : showHotDeal;

// property extra permissions
property.extrasMultiRateSupport = (typeof extrasMultiRateSupport === 'undefined') ? null : extrasMultiRateSupport;
property.extrasOptionsSupport = (typeof extrasOptionsSupport === 'undefined') ? null : extrasOptionsSupport;
property.extrasValiditySupport = (typeof extrasValiditySupport === 'undefined') ? null : extrasValiditySupport;

// group pax bookings
property.remainingLabel = (typeof remainingLabel === 'undefined') ? null : remainingLabel;
property.showGroupedPaxSelectors = (typeof showGroupedPaxSelectors === 'undefined') ? null : showGroupedPaxSelectors;
property.maxGroupedPaxSelectors = (typeof maxGroupedPaxSelectors === 'undefined') ? null : maxGroupedPaxSelectors;
property.defaultGroupPaxAmounts = (typeof defaultGroupPaxAmounts === 'undefined') ? null : defaultGroupPaxAmounts;

if(typeof ngInTesting !== 'undefined' && ngInTesting){
    property = ngTesting.getTestProperty();
}


property.isHotDeal = function(basePrice, currentPrice)
{
    if(!property.showHotDeal) return false;
    if(!basePrice || !currentPrice) return false;

    basePrice = basePrice * (1 - (property.hotDealPercentage / 100));

    return currentPrice <= basePrice;
};
property.isRoomOnRequest = function($index, checkinDate)
{
    return !!property.roomAvailabilities[$index].isOnRequest;
};
property.roomHasLimitedSpace = function($index)
{
    return !!property.roomAvailabilities[$index].isLimited;
};
propertyModule.factory('propertyFactory',function(){
    var client = property;
    return client;
});
property.confirmRedirect = function(){
    if(property.showRedirectConfirm && property.propertyHomeAddress) {
        if (confirm('By clicking this you will redirect and lose any progress. Are you sure you want to do this?')) {
            window.location.href = property.formatAddress(property.propertyHomeAddress);
        } else {
            return;
        }
    } else if(property.propertyHomeAddress) {
        window.location.href = property.formatAddress(property.propertyHomeAddress);
    }
};
property.closeAndReturn = function(){
    if(property.propertyHomeAddress && (typeof redirectOverride !== 'undefined' && redirectOverride)){
        window.location.href = property.formatAddress(property.propertyHomeAddress);
    } else {
        window.close();
    }
}

property.formatAddress = function(address){
    if(address.substring(0,4) !== 'http'){
        address = 'http://' + address;
    }
    return address;
};